import { useUserSession } from "@/hooks/useUserSession";
import { getPapersById } from "@/lib/cloudFunctions/getPapersById";
import { SearchResponseItem } from "@/lib/SemanticScholarApi";

import SearchArticle from "@/ui/SearchArticle";

import { Box, CircularProgress, Heading, VStack } from "@chakra-ui/react";

import { collection, getDocs, orderBy, query, limit } from "firebase/firestore";
import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

const History = () => {
  const { t } = useTranslation();
  const { user } = useUserSession();

  const [articles, setArticles] = useState<SearchResponseItem[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!user) return;
    (async () => {
      setLoading(true);
      const { docs } = await getDocs(
        query(
          collection(user.ref, "history"),
          orderBy("readAt", "desc"),
          limit(20)
        )
      );

      const ids = docs.map((doc) => parseInt(doc.id));

      const res = await getPapersById({
        papers_id: ids,
      });

      setLoading(false);
      setArticles(res.data.papers);
    })();
  }, [user]);
  return (
    <Box
      flex={1}
      display={"flex"}
      flexDir={"column"}
      alignItems={"center"}
      borderRadius={32}
      paddingX={[4, 4, 12]}
      paddingY={[2, 4]}
      bgColor={"white"}
    >
      <Heading mb={4} textAlign={"center"}>
        {t("profile.menu.history")}
      </Heading>
      <CircularProgress
        isIndeterminate={loading}
        hidden={!loading}
        color="brand.500"
      />
      <VStack spacing={4}>
        {articles.map((article) => (
          <SearchArticle key={article.paperId} {...article} />
        ))}
      </VStack>
    </Box>
  );
};

export default History;
